import { BaseModule } from '@mc/tangram-core'

export class Video extends BaseModule {
  render() {
    const { rawData, id, containerStyle } = this
    return {
      renderIdentifier: 'video',
      detail: rawData?.[0] || {},
      id,
      containerStyle
    }
  }
}
